import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { getRetinaImage, handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';
import './LayoutCredit.scss';

const LayoutCredit = (
  {
    awsFolderName,
    baseRequestUrl,
    content: {
      title,
      copy,
      copy_2: finePrint,
      image: {
        desktop: desktopImg = {},
        mobile: mobileImg = {},
      } = {},
      cta: {
        label: ctaLabel,
        aria_label: ariaLabel,
        url: ctaUrl,
      } = {},
    },
    matchMedia,
    tabHeading: heading,
    Analytics,
  }
) => {
  const specificParam = {
    tab_item: heading,
    action_name: `${ctaLabel} Click`,
  };

  const sanitizedHeading = sanitizeString(heading);
  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);
  const sanitizedFinePrint = sanitizeString(finePrint);
  const urlPrefix = `${baseRequestUrl}${awsFolderName}/carouselImages/tabBgImages/`;
  const imgName = getRetinaImage(desktopImg, mobileImg, matchMedia.xl);
  const bgImage = `url(${urlPrefix}${imgName})`;

  const style = (matchMedia.xl && imgName) ? { backgroundImage: bgImage } : {};

  return (
    <div
      className="LayoutCredit"
      {...{ style }}
    >
      {heading && (
      <h3
        className="LayoutCredit__heading  content-heading"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: sanitizedHeading,
        }}
      />
      )}
      <div className="LayoutCredit__inner">
        <div className="LayoutCredit__content">
          <div className="LayoutCredit__copy">
            {title && (
            <h3
              className="LayoutCredit__title"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedTitle,
              }}
            />
            )}
            {copy && (
            <div
              className="LayoutCredit__text"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedCopy,
              }}
            />
            )}
            {finePrint && (
            <div
              className="LayoutCredit__fine-print"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedFinePrint,
              }}
            />
            )}
          </div>
        </div>
        {(ctaLabel && ctaUrl) && (
          <Link
            href={ctaUrl}
            target="_blank"
            className="LayoutCredit__CTA"
            onClick={() => handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, specificParam)}
            aria-label={ariaLabel}
          >
            {ctaLabel}
          </Link>
        )}
        {(!matchMedia.xl && imgName) && (
          <img
            className="LayoutCredit__image"
            src={`${urlPrefix}${imgName}`}
            alt=""
          />
        )}
      </div>
    </div>
  );
};

LayoutCredit.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.string,
    copy_2: PropTypes.string,
    image: PropTypes.shape({
      desktop: PropTypes.shape({}).isRequired,
      mobile: PropTypes.shape({}).isRequired,
    }).isRequired,
    cta: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      item_name: PropTypes.string,
      action_name: PropTypes.string,
    }).isRequired,
    article_name: PropTypes.string,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  tabHeading: PropTypes.string,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

LayoutCredit.defaultProps = {
  tabHeading: '',
};

export default LayoutCredit;
